export default {
  NAME: '幸福存摺',
  SHORT_NAME: '幸福存摺',
};
